// 值类型
// 布尔型	0	该参数值类型对应前端显示为二值型checkbox框
// 整型	1	不带小数点
// 浮点型2  带小数点
// 字符串型3
// 枚举型4
import { trim } from '@/libs/utils';
const types = [
  {
    name: window.$t('com_form_type_integer'),
    value: 1,
    // 提示文字
    help: window.$t('com_form_validate_type_integer_range_help'),
    // 验证规则
    rangeValidator: function(value) {
      const newValue = trim(value);
      if (newValue === '') {
        return true;
      }
      if (!/^(-|\+)?\d+~(-|\+)?\d+$/.test(newValue)) {
        return window.$t('com_form_validate_type_integer_range_error1');
      }
      const newArray = newValue.split('~');
      if (Number(newArray[0]) >= Number(newArray[1])) {
        return window.$t('com_form_validate_type_integer_range_error2');
      }
      return true;
    },
    // 输入验证
    inputValidator: function(record, value) {
      // 判断值是不是不在可接受范围
      // 整数
      if (record.dataRange && typeof record.dataRange === 'string') {
        const arr = record.dataRange.split('~');
        let min, max;
        if (arr && arr.length) {
          if (arr.length === 1) {
            if (value === arr[0]) {
              return true;
            }
            return false;
          } else {
            min = Number(arr[0]);
            max = Number(arr[1]);
            if (min === max) {
              if (value === min) {
                return true;
              }
              return false;
            } else {
              if (value >= min && value <= max) {
                return true;
              }
              return false;
            }
          }
        }
        return true;
      }
      return true;
    },
  },

  {
    name: window.$t('com_form_type_float'),
    value: 2,
    help: window.$t('com_form_validate_type_float_range_help'),
    // 验证规则
    rangeValidator: function(value) {
      const newValue = trim(value);
      if (newValue === '') {
        return true;
      }
      if (!/^(-|\+)?\d+~(-|\+)?\d+\|\d{1,2}$/.test(newValue)) {
        return window.$t('com_form_validate_type_float_range_error1');
      }
      const newArray = newValue.split('|')[0].split('~');
      if (Number(newArray[0]) >= Number(newArray[1])) {
        return window.$t('com_form_validate_type_float_range_error2');
      }
      return true;
    },
    // 输入验证
    inputValidator: function(record, value) {
      // 判断值是不是不在可接受范围
      // 浮点型
      if (record.dataRange && typeof record.dataRange === 'string') {
        const arr = record.dataRange.split('|');
        if (arr && arr.length === 2) {
          const decimal = Number(arr[1]);
          // 判断小数位是否OK
          const valueDecimal = String(value).split('.')[1];
          if (valueDecimal && valueDecimal.length) {
            if (valueDecimal.length !== decimal) {
              return false;
            }
          }

          // 判断值是否在范围
          const arr2 = arr[0].split('~');
          if (arr2 && arr2.length === 2) {
            const min = Number(arr2[0]);
            const max = Number(arr2[1]);
            if (min === max) {
              if (value === min) {
                return true;
              }
              return false;
            } else {
              if (value >= min && value <= max) {
                return true;
              }
              return false;
            }
          }
        }
        return true;
      }
      return true;
    },
  },

  {
    name: window.$t('com_form_type_string'),
    value: 3,
    help: window.$t('com_form_validate_type_string_help'),
    // 验证规则
    rangeValidator: function(value) {
      const newValue = trim(value);
      if (newValue === '') {
        return true;
      }
      if (!/^(-|\+)?\d+~(-|\+)?\d+$/.test(newValue)) {
        return window.$t('com_form_validate_type_string_error1');
      }
      const newArray = newValue.split('~');
      if (Number(newArray[0]) >= Number(newArray[1])) {
        return window.$t('com_form_validate_type_string_error2');
      }
      return true;
    },

    // 输入验证
    inputValidator: function(record, value) {
      // 字符串
      if (record.dataRange && typeof record.dataRange === 'string') {
        const arr = record.dataRange.split('~');
        let min, max;
        if (arr && arr.length) {
          if (arr.length === 1) {
            if (value.length === arr[0]) {
              return true;
            }
            return false;
          } else {
            min = Number(arr[0]);
            max = Number(arr[1]);
            if (min === max) {
              if (value.length === min) {
                return true;
              }
              return false;
            } else {
              if (value.length >= min && value.length <= max) {
                return true;
              }
              return false;
            }
          }
        }
        return true;
      }
      return true;
    },
  },

  {
    name: window.$t('com_form_type_enumeration'),
    value: 4,
    help: window.$t('com_form_type_enumeration_help'),
    rangeValidator: function(value) {
      const newValue = trim(value);
      const newArray = newValue.split('\n');
      let check = true;
      newArray.every((item, index) => {
        const value = item.split('|');
        // 最多只允许3个｜线，最后一个竖线后为类型
        if (value.length > 3 || !/^(.)+\|(.)+$/.test(item)) {
          check = window.$t('com_form_type_enumeration_error1', {
            index: index + 1,
          });
          return false;
        }

        // 类型
        if (value.length === 3) {
          const valueType = value[2];
          if (
            valueType &&
            valueType !== 'string' &&
            valueType !== 'number' &&
            valueType !== 'boolean'
          ) {
            check = window.$t('com_form_type_enumeration_error2', {
              index: index + 1,
            });
            return false;
          }
        }

        return true;
      });
      return check;
    },
    // 输入验证
    inputValidator: function(_record, _value) {
      return true;
    },
  },
];

// 计算类型的值
const calcTypeValue = (record, value, valueName) => {
  // console.log('valueText', record.name);
  // console.log('record', record);
  // 枚举型
  if (record.dataType === 4) {
    if (record.dataRange) {
      const items = record.dataRange.split('\n');
      const options = [];
      items.forEach(item => {
        const temp = item.split('|');
        if (temp && temp.length === 2) {
          const tempObj = { name: temp[0], value: temp[1] };
          options.push(tempObj);
        }
      });
      // console.log('options', options);
      let valueText = options.find(item => item.value == record.value);
      // console.log('valueText', valueText);
      if (valueName) {
        valueText = options.find(item => item.value == record[valueName]);
      }
      if (valueText) {
        return valueText.name || '--';
      }
      return '--';
    }
    return '--';
  }

  // 其他类型
  if (value == 0 || value) {
    return value;
  }
  return '--';
};

const typesObject = {};
types.forEach(item => {
  typesObject[item.value] = item;
});

export default {
  array: types,
  object: typesObject,
  calcTypeValue,
};
